module.exports = __webpack_public_path__ + "static/pc.9bf5e372.png";